import "vue-directive-tooltip/css/index.css";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import Tooltip from "vue-directive-tooltip";

import { Unijs } from "@unimed/unijs/components";

Vue.config.productionTip = process.env.NODE_ENV === "production";

Vue.directive("tooltip", {});
Vue.use(Tooltip, {
  delay: 0,
  placement: "auto",
});

Vue.use(Unijs);

Vue.config.errorHandler = (error) =>
  global.setTimeout(() => {
    throw error;
  }, 0);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
